<template>
    <div style="background-color: #f3f3f3">
        <div class="top-line"></div>
        <b-container>
            <b-container class="title-container">
                <b-row>
                    <b-col class="title-left">
                        <p id="currentTime" class="little-shadow">{{ date }}</p>
                    </b-col>

                    <b-col class="title-right little-shadow" v-if="!username">
                        <p>
                            <a href="/login">登录</a>
                            |
                            <a href="/register">注册</a>
                        </p>
                    </b-col>

                    <b-col class="title-right" v-else>
                        <p>
                            <b-dropdown :text="username" variant="outline-light" size="sm" class="m-2"
                                style="margin-right:10px;font-size:16px;">
                                <b-dropdown-item to="/setting">个人信息</b-dropdown-item>
                                <b-dropdown-item to="/setting?index=1">修改密码</b-dropdown-item>
                            </b-dropdown>|
                            <a href="#" @click="logout" style="cursor:pointer" class="little-shadow">退出</a>
                        </p>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>

        <b-container v-if="left">
            <p class="big-title2" style="margin-top:80px; ">
                共享航次计划
                <!-- <b-button @click="change" pill variant="outline-secondary" size="small">切换</b-button> -->
            </p>
        </b-container>

        <!--<b-img style="object-fit: cover;width:40%;position:absolute;right:0;top:50px;" src="../statics/img-boat.png"></b-img>-->
        <b-img fluid :src="topLogo" style="position:absolute; height: 160px; left: 35%; top:30px"></b-img>        
        <b-img fluid style="min-height: 200px; max-height: 230px;object-fit: cover;width:100%;" :src="img"></b-img>
    </div>
</template>

<script>
import { getTimeFormat } from '../utils/date';
import Vue from 'vue';
import { clearLoginInfo } from '../utils';

const topBg1 = require('../statics/img-bg.png');
const topBg2 = require('../statics/img-bg.jpg');
const topBg3 = require('../statics/img-bg.png');
const topBg4 = require('../statics/topbg.jpg');
const topLogo = require('../statics/top-logo.png');

export default {
    name: 'GlobalTop',
    props: {},
    data() {
        return {
            date: '',
            username: Vue.ls.get('username'),
            img: topBg4,
            topLogo: topLogo,
            left: false
        };
    },

    mounted() {
        this.date = getTimeFormat();
        this.$root.eventHub.$on('loginSuccess', () => {
            this.username = Vue.ls.get('username');
        });

        this.$root.eventHub.$on('logout', () => {
            console.log('header logout');
            this.username = Vue.ls.get('username');
        });
    },

    unmounted() { },

    created() { },

    methods: {
        logout(e) {
            e.preventDefault();
            clearLoginInfo();
            this.$router.push({
                name: 'login'
            });
            this.username = Vue.ls.get('username');
        },
        change() {
            this.left = !this.left;
        }
    }
};
</script>

<style></style>

<style scoped>
.big-title {
    font-size: 34px;
    position: absolute;
    color: #0c5460;
    margin-top: 30px;
    text-align: center;
    color: #fff;
    text-shadow: 2px 2px 1px #000;
    width: 100%;
}

.big-title2 {
    font-size: 34px;
    /* font-weight: bold; */
    position: absolute;
    color: #0c5460;
    margin-top: 50px;
    text-align: center;
    color: #fff;
    text-shadow: 2px 2px 1px #000;
}

.little-shadow {
    text-shadow: 1px 1px 1px #115ca5;
}

#currentTime {
    padding: 0px;
    margin-left: -20px;
}

.top-line {
    margin-top: 50px;
    height: 0px;
    width: 100%;
    background: rgba(243, 243, 243, 0.1);
    position: absolute;
}

.title-container a {
    color: white;
}

.title-container {
    position: absolute;
    width: 100%;
    /* background-color: rgba(0, 0, 0, 0.1); */
}

.title-left {
    text-align: left;
    height: 50px;
    font-size: 16px;
    line-height: 50px;
    color: white;
}

.title-right {
    text-align: right;
    height: 50px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 50px;
    color: white;
}
</style>
